<ng-container wp-isolated-query-space>
  <filters-tab-inner #tabInner></filters-tab-inner>
</ng-container>
